export default __webpack_public_path__ + "static/media/pidsmaker.a45991e4.png";